import { Build } from '@project-lary/react-material-symbols-400-rounded';
import { DEPLOYMENT_WINDOW_END, DEPLOYMENT_WINDOW_START } from 'gcs-common/constants/maintenanceConstants';
import { getLogo } from 'gcs-common/slices/theme/themeSelectors';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';

const MaintenanceScreen = () => {
  const [now, setNow] = useState(() => new Date());
  const logo = useSelector(getLogo);

  useEffect(() => {
    const currentTime = now.getTime();

    if (currentTime < DEPLOYMENT_WINDOW_START.getTime()) {
      const timeout = window.setTimeout(
        () => setNow(new Date()),
        Math.max(0, DEPLOYMENT_WINDOW_START.getTime() - currentTime),
      );
      return () => window.clearTimeout(timeout);
    }

    if (currentTime < DEPLOYMENT_WINDOW_END.getTime()) {
      const timeout = window.setTimeout(
        () => setNow(new Date()),
        Math.max(0, DEPLOYMENT_WINDOW_END.getTime() - currentTime),
      );
      return () => window.clearTimeout(timeout);
    }
  }, [now]);

  const isVisible = now >= DEPLOYMENT_WINDOW_START && now < DEPLOYMENT_WINDOW_END;

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 z-[99999] flex flex-col overflow-hidden bg-white">
      <div className="flex shrink-0 items-center justify-center border-gray-200 border-b bg-[var(--theme-primary)] px-6 py-4">
        <img src={logo} alt="Logo" className="h-8 object-contain" />
      </div>
      <div className="flex min-h-0 flex-1 items-center justify-center px-6 py-8">
        <div className="flex flex-col items-center gap-5 text-center">
          <div className="flex h-20 w-20 items-center justify-center rounded-2xl bg-[var(--theme-primary-lighter)]">
            <Build className="text-[40px] text-secondary" />
          </div>
          <h1 className="m-0 font-bold text-2xl text-black">Gleich wieder da.</h1>
          <p className="m-0 max-w-xs text-gray-500 text-sm leading-relaxed">
            Beem wird gerade gewartet. Wir sind in Kürze wieder für Dich erreichbar - danke für Deine Geduld.
          </p>
          <div className="flex items-center gap-2 rounded-full bg-[var(--theme-primary-lighter)] px-4 py-2">
            <span className="h-2 w-2 rounded-full bg-secondary" />
            <span className="font-medium text-black text-sm">Wartung läuft</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MaintenanceScreen;
